import {
  SENDING_HUBS_REQUEST,
  FETCH_HUBS_SUCCESS,
  FETCH_HUBS_FAILURE,
  SENDING_HUB_CREATE,
  CREATE_HUB_FAILURE,
  SENDING_HUB_UPDATE,
  UPDATE_HUB_FAILURE,
  SENDING_HUB_DELETE,
  DELETE_HUB_FAILURE,
  SENDING_HUB_UPLOAD,
  UPLOAD_HUB_FAILURE,
  SENDING_HUB_UPGRADE,
  UPGRADE_HUB_FAILURE
} from '../actions/constants'

const initialState = {
  hubs: [],
  fetching: false,
  error: ''
}

const hub = (state = initialState, action) => {
  switch (action.type) {
    case SENDING_HUBS_REQUEST:
    case SENDING_HUB_CREATE:
    case SENDING_HUB_UPDATE:
    case SENDING_HUB_DELETE:
    case SENDING_HUB_UPLOAD:
    case SENDING_HUB_UPGRADE:
      return {
        ...state,
        fetching: action.sending
      }
    case FETCH_HUBS_SUCCESS:
      return {
        ...state,
        hubs: action.hubs
      }
    case FETCH_HUBS_FAILURE:
    case CREATE_HUB_FAILURE:
    case UPDATE_HUB_FAILURE:
    case DELETE_HUB_FAILURE:
    case UPLOAD_HUB_FAILURE:
    case UPGRADE_HUB_FAILURE:
      return {
        ...state,
        error: action.error
      }
    default:
      return state
  }
}

export default hub



// WEBPACK FOOTER //
// ./src/reducers/hub.js